export class AppointmentTypeDto {
    appointmentTypeId?: number = -1;
    appointmentTypeName: string = "";
    appointmentTypeTime: number = 0;
    athenaAppointmentTypeId?: number = undefined;
    appointmentProviders?: string = "";
}